import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaBlock } from './ui/CtaBlock';
import { PRODUCT_NAME, tomos } from '../data/content';
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-white" data-id="element-130" data-mp="3o9trxz6mahzz">
      <div className="mx-auto max-w-3xl px-4 py-4 sm:py-8" data-id="element-131" data-mp="3o77mq6778ekx">
        <SectionHeader id="solucion" eyebrow="La solución que estabas buscando — un sistema 6 en 1" title="6 tomos en un solo sistema, creados para organizar la enseñanza de electrónica desde los fundamentos hasta proyectos y diagnóstico." data-id="element-132" data-mp="3j9fsv6mzuie3" />
        <p className="mt-2 text-center font-condensed text-sm font-bold text-brand sm:text-base" data-id="element-133" data-mp="auno6yhi5xft">⚡ {PRODUCT_NAME}</p>
        <p className="mx-auto mt-1 max-w-2xl text-center text-sm leading-snug text-navy/75" data-id="element-134" data-mp="5wchgwmi831t">
          No es simplemente otro ebook de electrónica. Es una ruta educativa que organiza teoría, componentes,
          mediciones, circuitos, diagnóstico y prácticas para ayudarte a comprender qué enseñar primero, qué viene
          después y cómo llevar cada concepto al aula o taller.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-135" data-mp="3baqhv4pvjeqh">
          {tomos.map((tomo, i) => <li key={tomo.title} className="flex gap-2.5 rounded-lg border border-navy/10 bg-mist p-2.5 sm:p-3" data-id="element-136" data-mp="3fa92dzds9nss" data-mpi={i}>
              <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-brand font-numeric text-2xl leading-none text-energy" data-id="element-137" data-mp="3kb6je8n24bsp">
                {i + 1}
              </span>
              <div data-id="element-138" data-mp="3u705aimo1hn5">
                <p className="font-condensed text-[0.72rem] font-bold uppercase text-alert" data-id="element-139" data-mp="3u6gmz0t3sr8l">Tomo {i + 1}</p>
                <h3 className="font-condensed text-[0.95rem] font-bold leading-tight text-navy" data-id="element-140" data-mp="2w9immhtoevk">{tomo.title}</h3>
                <p className="mt-0.5 text-[0.8rem] leading-snug text-navy/75 sm:text-sm" data-id="element-141" data-mp="bulkjko52z3b">{tomo.desc}</p>
              </div>
            </li>)}
        </ol>

        <CtaBlock note="" data-id="element-142" data-mp="gty49wjprq1o" />
      </div>
    </section>;
}